/* global maplibregl */

Apt.fn.extend('maps', {
	/**
	 * Resize map to fit container
	 *
	 * @param {Function} [fn]
	 */
	resize(fn) {
		const scope = this;
		const priv = scope.$private;

		if (priv.working) {
			return;
		}

		if (fn) {
			scope.bind('map', 'resize', () => {
				fn();
			}, true);
		}

		requestAnimationFrame(() => {
			if (priv.map) {
				priv.map.resize();
			}
		});
	},

	/**
	 * Constrain map to bounds
	 *
	 * @param {Array} [bounds]
	 * @param {Object} [options]
	 * @param {Boolean} [options.animate=false]
	 * @param {Boolean} [options.duration=800]
	 * @param {Function} [options.fn]
	 * @param {Number} [options.maxZoom]
	 * @param {Number} [options.minZoom]
	 * @param {Boolean} [options.pad=true]
	 */
	constrain(bounds, options) {
		const scope = this;
		const priv = scope.$private;
		const conf = {
			animate: options.animate || false,
			duration: options.duration || 800
		};

		scope.hideTooltip();

		if (options.fn || options.minZoom) {
			scope.bind('map', 'moveend', () => {
				try {
					$.exec(options.fn);

					if (options.minZoom && priv.map.getZoom() < options.minZoom) {
						priv.map.setZoom(options.minZoom);
					}
				} catch (e) {
					//
				}
			}, true);
		}

		if (options.maxZoom) {
			conf.maxZoom = options.maxZoom;
		}

		bounds = scope.parseBounds(bounds || priv.default.bounds);

		if (! bounds) {
			return;
		}

		priv.map.fitBounds(
			scope.padBounds(bounds, options.pad || true), conf
		);
	},

	/**
	 * Center map to specified location
	 *
	 * @param {Array} [center]
	 * @param {Object} [options]
	 */
	center(center, options) {
		const scope = this;
		const priv = scope.$private;
		const conf = Object.assign({
			center: center || priv.default.center,
			maxDuration: 2000,
			panel: false,
			speed: 2.8,
			zoom: 14.4
		}, options);

		if (! scope.map || ! priv.validate(conf.center)) {
			return;
		}

		const data = {
			originalEvent: {}
		};

		scope.hideTooltip();

		if (scope.toggle) {
			scope.toggle.disable();
		}

		if (conf.animate && $.screen.size() > 2) {
			scope.map.flyTo(conf, data);
		} else {
			scope.map.jumpTo(conf, data);
		}
	},

	/**
	 * Center map on contextual geometry
	 *
	 * @param {Function} [fn]
	 */
	position(fn) {
		const scope = this;
		const priv = scope.$private;
		const loc = $.context('location');

		let bounds;
		let zoom;

		if (! loc) {
			if (scope.parsePosition()) {
				return;
			}

			bounds = priv.default.bounds;

			priv.location = null;
		} else {
			if (loc.slug === priv.location) {
				return;
			}

			priv.location = loc.slug;

			bounds = loc.bounds;
			zoom = priv.default.minZoom[loc.type];

			if (! bounds) {
				zoom = 11;

				scope.center(loc.center, {
					zoom: zoom
				});

				$.exec(fn);

				return;
			}
		}

		scope.constrain(bounds, {
			animate: true,
			fn: fn,
			minZoom: zoom
		});
	},

	/**
	 * Get formatted map center point
	 *
	 * @param {Boolean} [round=false]
	 * @returns {Array}
	 */
	getCenter(round) {
		const center = this.map.getCenter();

		return round ? [
			LS.util.round(center.lng, 6),
			LS.util.round(center.lat, 6)
		] : [
			center.lng,
			center.lat
		];
	},

	/**
	 * Get formatted map boundary
	 *
	 * @param {Boolean|Number} [pad=false]
	 * @param {Boolean} [round=true]
	 * @returns {Array}
	 */
	getBounds(pad, round = true) {
		const scope = this;
		const bounds = scope.parseBounds(
			scope.map.getBounds()
		);

		return bounds ?
			scope.padBounds(bounds, pad, round) : null;
	},

	/**
	 * Pad bounds with extra spacing
	 *
	 * @param {Array} bounds
	 * @param {Boolean|Number} [pad=0.05]
	 * @param {Boolean} [round=true]
	 * @returns {Array}
	 */
	padBounds(bounds, pad = 0, round = true) {
		if (bounds.length === 2) {
			bounds = [
				...bounds[0],
				...bounds[1]
			];
		}

		if (pad === true) {
			const $target = $(this.$private.conf.target);
			const height = $.height($target) || 360;
			const width = $.width($target) || 360;

			pad = Math.max(Math.max(
				Math.abs(bounds[0] - bounds[2]) / height,
				Math.abs(bounds[1] - bounds[3]) / width
			) * 90, 0.15);
		}

		bounds = [
			bounds[0] - pad,
			bounds[1] - pad,
			bounds[2] + pad,
			bounds[3] + pad
		];

		if (! round) {
			return bounds;
		}

		return bounds.map(val => LS.util.round(val, 6));
	},

	/**
	 * Normalize bounds into
	 *
	 * @param {Array|Object} bounds
	 * @returns {Array}
	 */
	parseBounds(bounds) {
		if (Array.isArray(bounds)) {
			if (bounds.length === 2) {
				return [
					bounds[0][0],
					bounds[0][1],
					bounds[1][0],
					bounds[1][1]
				];
			}

			return bounds;
		}

		if (typeof bounds !== 'object') {
			return null;
		}

		const lower = bounds._sw;
		const upper = bounds._ne;

		return [
			lower.lng,
			lower.lat,
			upper.lng,
			upper.lat
		];
	},

	/**
	 * Get map zoom level
	 *
	 * @param {Boolean} [round=false]
	 * @returns {Number}
	 */
	getZoom(round) {
		const val = this.map.getZoom();

		return round ?
			LS.util.round(val, 2) : val;
	},

	/**
	 * Remove drawing
	 *
	 * @param {Boolean} [reset=false]
	 */
	removeDraw(reset) {
		const priv = this.$private;
		const draw = priv.draw;

		if (draw) {
			if (reset) {
				draw.reset();
			}

			draw.$destroy();

			priv.draw = null;

			priv.model.$set('drawing', false);
		}
	},

	/**
	 * Execute function when map is ready
	 *
	 * @param {*} fn
	 * @param {Boolean} [listings=false]
	 * @returns {Object}
	 */
	ready(fn, listings) {
		const priv = this.$private;
		const name = 'paint-' + LS.util.uid();

		priv[name] = setInterval(() => {
			// Check back if map is working
			if (! priv.map || priv.working) {
				return;
			}

			// Check if listings are loading
			if (listings && priv.loading) {
				return;
			}

			// Continue if map is idle
			if (priv.map.isMoving() || ! priv.map.isStyleLoaded()) {
				return;
			}

			clearInterval(priv[name]);

			try {
				fn();
			} catch (e) {
				//
			}
		}, 25);

		return priv[name];
	},

	/**
	 * Get feature by ID
	 *
	 * @param {Number} id
	 * @returns {Object}
	 */
	getFeature(id) {
		return this.$private.layers.listings.find(point => point.id === id);
	},

	/**
	 * Check for WebGL support
	 *
	 * @returns {Boolean}
	 */
	supported() {
		if (window.WebGLRenderingContext) {
			const canvas = document.createElement('canvas');

			try {
				const context = canvas.getContext('webgl2') || canvas.getContext('webgl');

				if (context && typeof context.getParameter === 'function') {
					return true;
				}
			} catch (e) {
				//
			}
		}

		return false;
	}
}, {
	/**
	 * Simplify filter data
	 *
	 * @param {Object} filters
	 */
	stripFilters(filters) {
		delete filters.bounds;
		delete filters.buffer;
		delete filters.center;
		delete filters.location;
		delete filters.page;
		delete filters.sort;
		delete filters.sync;
		delete filters.zoom;
	},

	/**
	 * Determine which polygons are currently in view
	 *
	 * @param {'subterritories'|'territories'} type
	 * @param {Object} [criteria]
	 * @returns {Array}
	 */
	getVisibleGeometry(type, criteria) {
		const features = this.getUnique(
			this.map.queryRenderedFeatures(Object.assign({
				layers: [type],
				validate: false
			}, criteria))
		);

		// Extract feature IDs
		return features.map(el => el.id);
	},

	/**
	 * Validate center
	 *
	 * @param {Array} center
	 * @returns {Boolean}
	 */
	validate(center) {
		const lon = center[0];
		const lat = center[1];

		return ! (lon < -180 || lon > 180 || lat < -90 || lat > 90);
	}
});